var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', _vm._b({
    ref: "table",
    staticClass: "v-sheet--outlined nshop-order-view-section nshop-order-view-pins",
    class: {
      'has-scroll': _vm.hasScroll,
      'is-mobile': _vm.$vuetify.breakpoint.mobile
    },
    style: {
      '--pins-max-height': _vm.maxHeight
    },
    attrs: {
      "fixed-header": "",
      "items-per-page": -1,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "no-data-text": "발급된 상품권이 없습니다"
    },
    scopedSlots: _vm._u([_vm.label ? {
      key: "top",
      fn: function fn() {
        return [_c('div', {
          staticClass: "table-label px-1 white"
        }, [_vm._v(" 상품권"), _vm.items.length ? [_vm._v(" · " + _vm._s(_vm.items.length) + "장 · 충전완료 " + _vm._s(_vm.gainedCount) + " / 미충전 " + _vm._s(_vm.items.length - _vm.gainedCount))] : _vm._e()], 2)];
      },
      proxy: true
    } : null, _vm._l(_vm.headers.filter(function (h) {
      return h.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value,
              item = _ref.item;
          return [_c('span', {
            key: index,
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value, item))
            }
          })];
        }
      };
    })], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }